import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { TextArea } from '.';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "textarea"
    }}>{`TextArea`}</h1>
    <p>{`Better looking alternative to native HTML textarea`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'<TextArea />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      TextArea,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <TextArea mdxType="TextArea" />
    </Playground>
    <h2 {...{
      "id": "placeholder"
    }}>{`Placeholder`}</h2>
    <Playground __position={1} __code={'<TextArea placeholder=\"Zadejte...\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      TextArea,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <TextArea placeholder="Zadejte..." mdxType="TextArea" />
    </Playground>
    <h2 {...{
      "id": "full-width"
    }}>{`Full width`}</h2>
    <Playground __position={2} __code={'<TextArea isFullWidth />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      TextArea,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <TextArea isFullWidth mdxType="TextArea" />
    </Playground>
    <h2 {...{
      "id": "disable"
    }}>{`Disable`}</h2>
    <Playground __position={3} __code={'<TextArea isDisabled />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      TextArea,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <TextArea isDisabled mdxType="TextArea" />
    </Playground>
    <h2 {...{
      "id": "resize"
    }}>{`Resize`}</h2>
    <Playground __position={4} __code={'<TextArea allowResize />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      TextArea,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <TextArea allowResize mdxType="TextArea" />
    </Playground>
    <h2 {...{
      "id": "known-bugs"
    }}>{`Known bugs`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`size`}</inlineCode>{` does not work`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`isDisabled`}</inlineCode>{` makes the component look like its disabled, but it is not => you can write into`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      